import { renderAboutIcon } from "../AboutIcons/AboutIcons.jsx";
import "./AboutStats.css";

export default function AboutStats({ stats }) {
  return (
    <div className="about-preview__stats">
      {stats.map((item, index) => (
        <article
          className={`about-preview__stat reveal-on-scroll reveal-on-scroll--scale reveal-delay-${
            (index % 4) + 1
          }`}
          key={index}
        >
          <span>{renderAboutIcon(item.icon)}</span>

          <div>
            <strong>{item.value}</strong>
            <p>{item.label}</p>
          </div>
        </article>
      ))}
    </div>
  );
}